import { render, staticRenderFns } from "./Proton.vue?vue&type=template&id=8ca99708&scoped=true"
import script from "./Proton.vue?vue&type=script&lang=js"
export * from "./Proton.vue?vue&type=script&lang=js"
import style0 from "./Proton.vue?vue&type=style&index=0&id=8ca99708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca99708",
  null
  
)

export default component.exports